import { IFilterProto } from '@monorepo/controlled/src/models/filter.model';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IMFPPStore } from '../../stores/index';
import { ITableFiltersActions, TableFilters } from '@monorepo/base/src/components/table/table-filters/table-filters';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { reportFilterPrototypes } from '../../components/filters';
import { PublisherStoreFiltersKeys } from '../../stores/reports/publisher.store';

interface IReportsActions {
	availableFilters?: IFilterProto[];
}

export const useReportsActions = (props: IReportsActions = {}) => {
	const { availableFilters } = props;
	const { settingsStore } = useStores<IMFPPStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();

	const filterStore = settingsStore
		.getPages()
		.get(currentRouteWithoutSpecialChars)
		?.tableStore.getFiltersStore(currentRouteWithoutSpecialChars as PublisherStoreFiltersKeys);
	const currentFilters = filterStore?.getCurrentFilters();

	const DefaultAvailableFilters = [...reportFilterPrototypes];

	const FiltersActions = (props: ITableFiltersActions) => {
		if (!currentFilters) {
			return null;
		}

		return (
			<TableFilters
				{...props}
				availableFilters={availableFilters || DefaultAvailableFilters}
				currentFilters={currentFilters}
				clearAll={() => filterStore?.clearAll()}
				clearFilter={index => filterStore?.clearFilter(index)}
				addFilter={filter => filterStore?.addFilter(filter)}
				editFilter={(index, filter) => filterStore?.editFilter(index, filter)}
			/>
		);
	};

	return {
		FiltersActions,
	};
};
